var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "order-warning-template" }, [
    _c(
      "div",
      { staticClass: "detailSection" },
      [
        _c("div", { staticClass: "title" }, [_vm._v("预警信息")]),
        _vm._l(_vm.info.riskWarnDetails, function (item, index) {
          return _c("ul", { key: index, staticClass: "list" }, [
            _c("li", { staticClass: "item flex1" }, [
              _c("div", { staticClass: "value" }, [_vm._v(_vm._s(item))]),
            ]),
          ])
        }),
      ],
      2
    ),
    _c("div", { staticClass: "detailSection" }, [
      _c("div", { staticClass: "title" }, [_vm._v("审核信息")]),
      _c("ul", { staticClass: "list" }, [
        _c("li", { staticClass: "item" }, [
          _c("div", { staticClass: "lang" }, [_vm._v("审核状态：")]),
          _c("div", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm.info.reviewStatusText)),
          ]),
        ]),
        _c("li", { staticClass: "item" }, [
          _c("div", { staticClass: "lang" }, [_vm._v("审核用户：")]),
          _c("div", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm._f("filterEmpty")(_vm.info.reviewNickName))),
          ]),
        ]),
        _c("li", { staticClass: "item" }, [
          _c("div", { staticClass: "lang" }, [_vm._v("审核时间：")]),
          _c("div", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm._f("filterEmpty")(_vm.info.reviewTime))),
          ]),
        ]),
      ]),
      _c("ul", { staticClass: "list" }, [
        _c("li", { staticClass: "item flex1" }, [
          _c("div", { staticClass: "lang" }, [_vm._v("审核说明：")]),
          _c("div", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm._f("filterEmpty")(_vm.info.remarks))),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }